module.exports = __webpack_public_path__ + "img/kexuezhongxing.06260249.jpg";